module.exports = __webpack_public_path__ + "img/example-shadowbox.5fef3265.png";